var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center",staticStyle:{"width":"100%"},style:({
    marginLeft: `-${_vm.contentAlignment === 'left' ? _vm.contentOffset : 0}px`,
  })},[_c('div',{staticClass:"commentable-document"},[_vm._t("default")],2),(_vm.blockMetaData.isHovered)?_c('div',{style:({
      width: '10px',
      position: 'relative',
    })},[_c('commentable-activator',{attrs:{"position":_vm.blockMetaData.position,"comments":_vm.blockMetaData.comments,"contentAlignment":_vm.contentAlignment},on:{"update:contentAlignment":function($event){_vm.contentAlignment=$event},"update:content-alignment":function($event){_vm.contentAlignment=$event}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }